export interface PromotionResponse {
  promoId: number
  promoName: string
  startDate: string
  endDate: string
  minAmt: number
  threshold: number
  status: string
  splashScreen: string
  banner: string
  leftImage: string
  rightImage: string
  promoType: PromoType
  maxEntries: number
  noOfItemsPerEntry: number
  thresholdNoOfItems: number
  promotionLinks: PromotionUrl[]
}

export interface PromotionCoverageResponse {
  coverage: string
}

export enum PromoType {
  AmountDriven = 1,
  BrandDriven = 4,
}

export interface PromotionUrl {
  name: string
  url: string
}

export interface EntriesUrl {
  numberOfEntries: number
}

export interface KeywordsAdsUrl {
  adbanners: string
}
